
















































































































































































































































































































import Vue from 'vue';
import ChartFileExtension from '../ChartGroup/Chart/ChartFileExtension.vue';
import ChartDamagedFile from '../ChartGroup/Chart/ChartDamagedFile.vue';
import ChartFileResolution from '../ChartGroup/Chart/ChartFileResolution.vue';
import ChartFileSize from '../ChartGroup/Chart/ChartFileSize.vue';
import ChartFileTable from './Chart/ChartFileTable.vue';
import Chart from './Chart/ChartContainer.vue';
import ChartLabelDistHistogram from './Chart/ChartLabelDistHistogram.vue';
import ChartLabelSortedClassHistogram from './Chart/ChartLabelSortedClassHistogram.vue';
import ChartLabelBoxplot from './Chart/ChartLabelBoxplot.vue';
import ChartLabelError from './Chart/ChartLabelError.vue';
import ChartLabelClassDonut from './Chart/ChartLabelClassDonut.vue';
import ChartGroupTemplate from './ChartGroupTemplate.vue';
import ChartLabelTotalError from './Chart/ChartLabelTotalError.vue';
import ChartLabelArrayCountBoxplot from './Chart/ChartLabelArrayCountBoxplot.vue';
import ChartLabelSchemaErrorBar from './Chart/ChartLabelSchemaErrorBar.vue';
import ChartWordCloud from './Chart/ChartWordCloud.vue';
import UniversalBarChart from '../../common/Chart/UniversalBarChart.vue';
import UniversalCountChart from '../../common/Chart/UniversalCountChart.vue';

let lastSelected = '';

export default Vue.extend({
  props: {
    selectedCharacteristic: {
      type: String,
      default: '',
    },
    isLabelPropSelected: {
      type: Boolean,
      default: false,
    },
    isLabelset: {
      type: Boolean,
      default: false,
    },
    datasetType: {
      type: String,
      default: '',
    },
  },
  components: {
    ChartFileExtension,
    ChartDamagedFile,
    ChartFileResolution,
    ChartFileSize,
    ChartFileTable,
    Chart,
    ChartLabelDistHistogram,
    ChartLabelSortedClassHistogram,
    ChartLabelBoxplot,
    ChartLabelError,
    ChartLabelClassDonut,
    ChartGroupTemplate,
    ChartLabelTotalError,
    ChartLabelArrayCountBoxplot,
    ChartLabelSchemaErrorBar,
    ChartWordCloud,
    ChartHistogram: UniversalBarChart,
    ChartBoxplot: UniversalCountChart,
  },
  data() {
    return {};
  },
  computed: {
    datasetCount(): number {
      return this.$store.getters.totalDataNumber;
    },
    isChartFileExtensionShowable(): boolean {
      return this.selectedCharacteristic === '';
    },
    isChartDamagedFileShowable(): boolean {
      return (
        this.selectedCharacteristic === '' ||
        this.selectedCharacteristic === '손상 파일 개수'
      );
    },
    isChartFileResolutionShowable(): boolean {
      return (
        this.selectedCharacteristic === '' ||
        this.selectedCharacteristic === '해상도 분포'
      );
    },
    isChartFileSizeShowable(): boolean {
      return (
        this.selectedCharacteristic === '' ||
        this.selectedCharacteristic === '파일크기 분포'
      );
    },
    isChartFileTableShowable(): boolean {
      return this.selectedCharacteristic !== '';
    },
    isChartDurationShowable(): boolean {
      console.log(this.selectedCharacteristic);
      return (
        this.selectedCharacteristic === '' ||
        this.selectedCharacteristic === '길이 분포'
      );
    },
    isChartDurationTableShowable(): boolean {
      return this.selectedCharacteristic !== '';
    },
    isChartSampleRateShowable(): boolean {
      return (
        this.selectedCharacteristic === '' ||
        this.selectedCharacteristic === '샘플링 레이트'
      );
    },
    lastSelectedProp(): string {
      if (this.selectedCharacteristic === '') {
        return lastSelected;
      } else {
        lastSelected = this.selectedCharacteristic;
        return this.selectedCharacteristic;
      }
    },
  },
});
